import HomeIcon from '@mui/icons-material/Home'
import UsersIcon from '@mui/icons-material/People'
import BusinessIcon from '@mui/icons-material/Business'
import { Outlet } from 'react-router-dom'
import { Box, Toolbar } from '@mui/material'
import ResponsiveNav from '../ResponsiveNav'

const drawerWidth = 240

const navList = [
  {
    icon: <UsersIcon />,
    label: 'Users',
    to: '/admin/users',
  },
  {
    icon: <BusinessIcon />,
    label: 'Dealerships',
    to: '/admin/dealerships',
  },
]

export default function AdminLayout() {
  return (
    <Box sx={{ display: 'flex' }}>
      <ResponsiveNav routes={navList} />
      <Box
        sx={{
          flexGrow: 1,
          maxHeight: { xs: '100%', md: 'auto' },
          height: '100%',
          width: { xs: '100%', md: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        <Box component='main' sx={{ flexGrow: 1, p: 3 }}>
          <Outlet />
          <Toolbar />
        </Box>
      </Box>
    </Box>
  )
}
